var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('a-authorization-card',{staticClass:"ma-5",attrs:{"color":"error","icon":"mdi-cancel","title":"Oups...","text":"Il n'y a rien ici.","sub":"Veuillez retourner à l'accueil."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }